const initHeaderMenuToggle = () => {
    const menuToggle = document.querySelector('.js-header-menu-toggle');
    const nav = document.querySelector('.js-header-nav');
    
    if (!menuToggle || !nav) {
        return;
    }

    // Function to check if we're in mobile view (max-width: 992px)
    const isMobileView = () => {
        return window.matchMedia('(max-width: 992px)').matches;
    };

    // Toggle active class on click (only in mobile view)
    menuToggle.addEventListener('click', function(e) {
        if (!isMobileView()) {
            return;
        }
        
        e.preventDefault();
        menuToggle.classList.toggle('is-active');
        
        // Optional: Toggle navigation visibility
        if (nav) {
            nav.classList.toggle('is-open');
        }
    });

    // Remove active class when resizing to desktop view
    const handleResize = () => {
        if (!isMobileView() && menuToggle.classList.contains('is-active')) {
            menuToggle.classList.remove('is-active');
            if (nav) {
                nav.classList.remove('is-open');
            }
        }
    };

    window.addEventListener('resize', handleResize);
    
    // Optional: Close menu when clicking outside (mobile only)
    document.addEventListener('click', function(e) {
        if (!isMobileView()) {
            return;
        }
        
        const isClickInsideNav = nav && nav.contains(e.target);
        const isClickOnToggle = menuToggle.contains(e.target);
        
        if (!isClickInsideNav && !isClickOnToggle && menuToggle.classList.contains('is-active')) {
            menuToggle.classList.remove('is-active');
            if (nav) {
                nav.classList.remove('is-open');
            }
        }
    });
}

export { initHeaderMenuToggle };

